import actionCreatorFactory from "../util/redux/action-factory";
import { reducerWithInitialState } from "../util/redux/typed-reducers";
import * as request from "../util/request";
import { env } from "../util/env";
import { ReduxState, ReduxDispatch } from "./reducers";
import {
    AnnualPaymentPlanDto,
    PaymentPlanDto,
} from "../util/DTOs/PaymentPlanDtos";

const actionFactory = actionCreatorFactory("HypoMobiili/loaninstalments");

const getAnnualPaymentPlansAction = actionFactory<
    null,
    Array<AnnualPaymentPlanDto>,
    string
>("GET_ANNUAL_PAYMENT_PLANS");

export function fetchAnnualPaymentPlanData(agreementId: number) {
    return async (
        dispatch: ReduxDispatch
    ): Promise<Array<AnnualPaymentPlanDto>> => {
        try {
            dispatch(getAnnualPaymentPlansAction(null));

            const result = await request.get<Array<AnnualPaymentPlanDto>>(
                `${env.APP_API_HOST}/api/PaymentPlanService?agreementId=${agreementId}`
            );
            dispatch(getAnnualPaymentPlansAction.done(result));
            return result;
        } catch (err) {
            dispatch(getAnnualPaymentPlansAction.failed(err));
            throw err;
        }
    };
}

export interface LoanInstalmentsState {
    data?: Array<AnnualPaymentPlanDto>;
    loading: boolean;
}

const initialLoanInstalmentsState: LoanInstalmentsState = {
    data: undefined,
    loading: false,
};

export const LoanInstalmentsReducer = reducerWithInitialState(
    initialLoanInstalmentsState
)
    .case(getAnnualPaymentPlansAction, (state, action) => {
        return {
            ...state,
            loading: true,
        };
    })
    .case(getAnnualPaymentPlansAction.done, (state, action) => {
        return {
            ...state,
            data: action.payload,
            loading: false,
        };
    })
    .case(getAnnualPaymentPlansAction.failed, (state, action) => {
        return {
            ...state,
            loading: false,
        };
    });

export default LoanInstalmentsReducer;



// WEBPACK FOOTER //
// ./src/ducks/loaninstalments.ts